export default __webpack_public_path__ + "fb57abb49b1453e256a2cb6b513ade92.png";